









import { Component, Prop, Vue } from 'vue-property-decorator';
import { Spinner } from '@/external/telstra-ui-vue/components';

@Component({
  components: {
    Spinner,
  },
})
export default class AppSpinnerModal extends Vue {
  @Prop() message?: string;

  showModal() {
    (this.$refs.spinnerModal as any).show();
  }

  hideModal() {
    (this.$refs.spinnerModal as any).hide();
  }
}

